import { Method, send } from "./MyHttp";

/**
 * 정보
 */
export const Get = (id, success, fail) => {
    const params = {};
    send(Method.GET, "/config/" + id, params, success, fail);
};
